import { create } from 'zustand';

interface SidebarState {
  isCollapsed: boolean;
  toggleCollapse: () => void;
  setCollapsed: (isCollapsed: boolean) => void;
  isHistoryOpen: boolean;
  isDocumentationOpen: boolean;
  toggleHistory: () => void;
  toggleDocumentation: () => void;
}

const useSideBarState = create<SidebarState>()((set, get) => ({
  isCollapsed: false,
  isHistoryOpen: false,
  isDocumentationOpen: false,

  toggleCollapse: () => {
    set({
      isCollapsed: !get().isCollapsed,
    });
  },
  toggleHistory: () => {
    set({
      isHistoryOpen: !get().isHistoryOpen,
    });
  },
  toggleDocumentation: () => {
    set({
      isDocumentationOpen: !get().isDocumentationOpen,
    });
  },
  setCollapsed: (isCollapsed: boolean) => {
    set({
      isCollapsed,
    });
  },
}));

export default useSideBarState;
